import { configureStore } from '@reduxjs/toolkit';
import reduxReducer from './reduxSlice';
import snackbarReducer from './snackbarSlice';

export const store = configureStore({
  reducer: {
    redux: reduxReducer,
    snackbar: snackbarReducer,
  },
});